class ProductInfo extends HTMLElement {
  constructor() {
    super();
  }
  
  get productForm() {
    return this.querySelector(`product-form`);
  }

  connectedCallback() {
    this.bindedHandleVariantChange = this.handleVariantChange.bind(this);
    this.bindedHandleTransitionEnd = this.handleTransitionEnd.bind(this);
    this.querySelector('.variant-selects')?.addEventListener('change', this.bindedHandleVariantChange);
    this.querySelector('.product__gallery').addEventListener('transitionend', this.bindedHandleTransitionEnd);
  }
  
  disconnectedCallback() {
    this.querySelector('.variant-selects')?.removeEventListener('change', this.bindedHandleVariantChange);
    this.querySelector('.product__gallery').removeEventListener('transitionend', this.bindedHandleTransitionEnd);
  }

  handleVariantChange(event) {
    this.resetProductFormState();

    const selectedOptionValues = Array.from(this.querySelectorAll('fieldset input:checked')).map(({ dataset }) => dataset.optionValueId);

    const productUrl = event.target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
    this.pendingRequestUrl = productUrl;
    const shouldFetchFullPage = this.dataset.url !== productUrl;

    this.renderProductInfo({
      requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
      targetId: event.target.id,
      callback: shouldFetchFullPage
        ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
        : this.handleUpdateProductInfo(productUrl),
    });
  }

  resetProductFormState() {
    this.productForm?.toggleSubmitButton(true);
    this.productForm?.handleErrorMessage();
  }

  buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
    const params = [];

    !shouldFetchFullPage && params.push(`section_id=${this.dataset.section}`);

    if (optionValues.length) {
      params.push(`option_values=${optionValues.join(',')}`);
    }

    return `${url}?${params.join('&')}`;
  }

  renderProductInfo({ requestUrl, targetId, callback }) {
    fetch(requestUrl)
      .then((response) => response.text())
      .then((responseText) => {
        this.pendingRequestUrl = null;
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        callback(html);
      })
      .then(() => {
        // set focus to last clicked option value
        document.querySelector(`#${targetId}`)?.focus();
      })
      .catch((error) => {
        console.error(error);
      });
  }

  handleSwapProduct(productUrl, updateFullPage) {
    return (html) => {
      const variant = this.getSelectedVariant(html.querySelector('product-info'));
      this.updateURL(productUrl, variant?.id);

      if (updateFullPage) {
        document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

        // might have to change later if add scripts to product page since by default, scripts are disabled when using element.innerHTML.
        document.querySelector('main').innerHTML = html.querySelector('main').innerHTML;
      } else {
        document.querySelector('product-info').innerHTML = html.querySelector('product-info').innerHTML;
      }
    };
  }

  handleUpdateProductInfo(productUrl) {
    return (html) => {
      const variant = this.getSelectedVariant(html);
      this.updateURL(productUrl, variant?.id);

      if (!variant) {
        this.setUnavailable();
        return;
      }

      if (variant?.featured_media?.id != this.getSelectedVariant(this)?.featured_media?.id) {
        this.updateMedia(html);
      }


      this.updateOptionValues(html);
      this.updateVariantInputs(variant?.id);
      this.updatePrice(html);
      this.updateForms(html);
    };
  }

  getSelectedVariant(productInfoNode) {
    const selectedVariant = productInfoNode.querySelector('[data-selected-variant]')?.innerHTML;
    return !!selectedVariant ? JSON.parse(selectedVariant) : null;
  }

  updateURL(url, variantId) {
    window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
  }

  updateOptionValues(html) {
    const variantSelects = html.querySelector('.variant-selects');
    if (variantSelects && this.querySelector('.variant-selects')) {
      this.querySelector('.variant-selects').innerHTML = variantSelects.innerHTML;
    }
  }

  updateVariantInputs(variantId) {
    this.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`).forEach((productForm) => {
      productForm.querySelector('input[name="id"]').value = variantId ?? '';
    });
  }

  updatePrice(html) {
    const price = html.querySelector('.product__price');
    if (price && this.querySelector('.product__price')) {
      this.querySelector('.product__price').innerHTML = price.innerHTML;
    }
  }

  updateForms(html) {
    const price = html.querySelector('.product__forms');
    if (price && this.querySelector('.product__forms')) {
      this.querySelector('.product__forms').innerHTML = price.innerHTML;
    }
  }

  setUnavailable() {
    this.productForm?.toggleSubmitButton(true, 'Unavailable');
  }

  updateMedia(html) {
    this.mediaGallerySource = this.querySelector('.product__gallery');
    this.mediaGalleryDestination = html.querySelector(".product__gallery");
    if (this.mediaGallerySource && this.mediaGalleryDestination) {
      this.mediaGallerySource.classList.add('loading');
    };
  }

  handleTransitionEnd(event) {
    if (event.currentTarget.classList.contains('loading') && this.bindedHandleTransitionEnd && this.mediaGalleryDestination) {
      this.mediaGallerySource.innerHTML = this.mediaGalleryDestination.innerHTML;
      event.currentTarget.classList.remove('loading');
    }
  }
}

customElements.define('product-info', ProductInfo);
